import './formikTimePickerComponent.scss'
import React from 'react';
import {FieldProps} from "formik";
import _ from "lodash";
import TimePickerComponent from "../time-picker/timePickerComponent";
import {Moment} from "moment";

interface FormikTimePickerComponentProps {
    id?: string;
    label: string;
    placeholder?: string;
    required?: boolean;
    disabled?: boolean;
    readonly?: boolean;
    variant?: "filled" | "standard" | "outlined" | undefined;
    color?: "error" | "primary" | "secondary" | "info" | "success" | "warning" | undefined;
    onUpdate?: Function;
    formikField: FieldProps;
    size?: "small" | "medium" | undefined;
    fullWidth?: boolean;
    maxTime?:Moment;
}

const FormikTimePickerComponent = (props: FormikTimePickerComponentProps) => {
        const {
            id,
            label,
            disabled,
            readonly,
            required,
            formikField,
            fullWidth,
            maxTime
        } = props;
        let {placeholder, color, variant, size, onUpdate} = props;
        if (!placeholder) placeholder = label;
        if (!color) color = "secondary";
        if (!variant) variant = "outlined";
        if (!size) size = "medium";

        const {field, form} = formikField;
        const {name, value} = field;
        const {setFieldTouched,touched, errors, setFieldValue} = form;
        const hasError = _.get(touched, name) && !!(_.get(errors, name));
        const handleChange = (newValue: Date | null) => {
            setFieldValue(name, newValue);
            setFieldTouched(name);
            if (onUpdate){
                onUpdate(newValue);
            }
        };

        return (
            <div>
                <TimePickerComponent
                    name={name}
                    label={label}
                    placeholder={placeholder}
                    value={value}
                    id={id}
                    size={size}
                    variant={variant}
                    color={color}
                    disabled={disabled}
                    readonly={readonly}
                    fullWidth={fullWidth}
                    required={required}
                    onUpdate={handleChange}
                    hasError={hasError}
                    errorMessage={hasError && _.get(errors, name)}
                    maxTime={maxTime}
                />
            </div>

        )
    }

;

export default FormikTimePickerComponent;
